// extracted by mini-css-extract-plugin
export default {"footerBox":"ngGsCCVL4W4Tp1s5pw6Y"};